(function () {
  const existing = window.VenadaBeforeAfter;
  if (existing && existing.assetInitialized === true) {
    existing.initAll(document);
    return;
  }

  const instances = new WeakMap();
  const clampValue = (value) => Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
  const valueText = (value) => value === 0
    ? 'Original photo fully visible'
    : value === 100
      ? 'Finished portrait fully visible'
      : `${value}% finished portrait visible`;
  const valueFromPointer = (clientX, rect) => clampValue(((clientX - rect.left) / rect.width) * 100);
  const valueForKey = (key, current) => {
    if (key === 'ArrowLeft') return clampValue(current - 5);
    if (key === 'ArrowRight') return clampValue(current + 5);
    if (key === 'Home') return 0;
    if (key === 'End') return 100;
    return null;
  };

  function init(root) {
    if (!root || instances.has(root)) return;
    const stage = root.querySelector('[data-venada-comparison-stage]');
    const image = root.querySelector('[data-venada-comparison-finished]');
    const label = root.querySelector('[data-venada-comparison-label]');
    const buttons = root.querySelectorAll('[data-venada-comparison-style]');
    if (!stage || !image || !label) return;

    root.dataset.venadaBeforeAfterReady = 'true';
    let value = 52;
    const update = (next) => {
      value = clampValue(next);
      stage.style.setProperty('--venada-comparison-value', `${value}%`);
      stage.setAttribute('aria-valuenow', String(value));
      stage.setAttribute('aria-valuetext', valueText(value));
    };
    const updateFromPointer = (event) => update(valueFromPointer(event.clientX, stage.getBoundingClientRect()));
    const onPointerDown = (event) => {
      stage.setPointerCapture(event.pointerId);
      updateFromPointer(event);
    };
    const onPointerMove = (event) => {
      if (stage.hasPointerCapture(event.pointerId)) updateFromPointer(event);
    };
    const onPointerEnd = (event) => {
      if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
    };
    const onKeyDown = (event) => {
      const next = valueForKey(event.key, value);
      if (next === null) return;
      event.preventDefault();
      update(next);
    };
    const buttonListeners = [];

    stage.addEventListener('pointerdown', onPointerDown);
    stage.addEventListener('pointermove', onPointerMove);
    stage.addEventListener('pointerup', onPointerEnd);
    stage.addEventListener('pointercancel', onPointerEnd);
    stage.addEventListener('keydown', onKeyDown);
    buttons.forEach((button) => {
      const onClick = () => {
        buttons.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));
        image.src = button.dataset.imageUrl;
        image.alt = button.dataset.imageAlt;
        image.classList.remove('is-changing');
        void image.offsetWidth;
        image.classList.add('is-changing');
        label.textContent = `${button.dataset.venadaComparisonStyle} portrait`;
      };
      button.addEventListener('click', onClick);
      buttonListeners.push([button, onClick]);
    });

    instances.set(root, () => {
      stage.removeEventListener('pointerdown', onPointerDown);
      stage.removeEventListener('pointermove', onPointerMove);
      stage.removeEventListener('pointerup', onPointerEnd);
      stage.removeEventListener('pointercancel', onPointerEnd);
      stage.removeEventListener('keydown', onKeyDown);
      buttonListeners.forEach(([button, onClick]) => button.removeEventListener('click', onClick));
      delete root.dataset.venadaBeforeAfterReady;
    });
  }

  function destroy(root) {
    const cleanup = instances.get(root);
    if (!cleanup) return;
    cleanup();
    instances.delete(root);
  }

  function initAll(scope) {
    const container = scope || document;
    if (container.matches?.('[data-venada-before-after]')) init(container);
    container.querySelectorAll?.('[data-venada-before-after]').forEach(init);
  }

  function destroyAll(scope) {
    const container = scope || document;
    if (container.matches?.('[data-venada-before-after]')) destroy(container);
    container.querySelectorAll?.('[data-venada-before-after]').forEach(destroy);
  }

  window.VenadaBeforeAfter = {
    assetInitialized: true,
    clampValue,
    valueText,
    valueFromPointer,
    valueForKey,
    init,
    initAll,
    destroy,
    destroyAll
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyAll(event.target));
}());
